import axios from "axios";
import { IParamsSearchLocation, IParamsSimpleCategory, IParamsTermClasses } from "../models/params";
import { APP_CONFIGURATION_KEYS, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE, SEARCH_OBJECT_MAX_SIZE } from "./Constant";
import { localStorageItem } from "./LocalStorage";
import { KEY_LOCALSTORAGE } from "../auth/core/_consts";
import { OctResponse } from "../models/OctResponse";
import { PagingParams } from "./ParamsUtils";

const API_PATH_EMR = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_API_URL;
const API_PATH_TERM_CLASSES = API_PATH_EMR + "/term-classes";
const API_PATH_XADMIN = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL;
const API_PATH_SSO = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.SSO_URL] || process.env.REACT_APP_API_URL;
const API_PATH_INS = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.INS_URL] || process.env.REACT_APP_INS_API_URL;

const API_PATH_CATEGORY = API_PATH_XADMIN + "/simple-categories";
const API_PATH_PROVINCES = API_PATH_XADMIN + "/provinces";
const API_PATH_DISTRICTS = API_PATH_XADMIN + "/districts";
const API_PATH_SUB_DISTRICTS = API_PATH_XADMIN + "/subdistricts";

export const getSimpleCategory = (params: IParamsSimpleCategory) => {
    let url = API_PATH_CATEGORY + "/search";
    return axios.get(url, { params: {
        ...params,
        ...SEARCH_OBJECT_MAX_SIZE
    } });
};

export const getTermByClassId = (params: {
    classId: number
}) => {
    let url = API_PATH_EMR + "/terms";
    return axios.get(url, { params });
};

export const getTermClasses = (params: IParamsTermClasses) => {
    let url = API_PATH_TERM_CLASSES + "/terms";
    return axios.get(url, { params });
};

export const getAllProvinces = () => {
    const MAX_PAGE_SIZE_PROVINCE = 63;
    let params = {
        pageIndex: DEFAULT_PAGE_INDEX,
        pageSize: MAX_PAGE_SIZE_PROVINCE
    };
    let url = API_PATH_PROVINCES + "/search";
    return axios.get(url, { params });
};

export const getAllDistricts = () => {
    let params = SEARCH_OBJECT_MAX_SIZE;
    let url = API_PATH_DISTRICTS + "/search";
    return axios.get(url, { params });
};

export const getAllSubDistricts = () => {
    let params = SEARCH_OBJECT_MAX_SIZE;
    let url = API_PATH_SUB_DISTRICTS + "/search";
    return axios.get(url, { params });
};

export const getAllSubDistrictsAllRelated = () => { //get old w-d-p
  let params = SEARCH_OBJECT_MAX_SIZE;
  let url = API_PATH_SUB_DISTRICTS + "/all-related";
  return axios.get(url, {params});
};

export const generateCode = () => {
    let url = API_PATH_EMR + `/generate/codes/patient`
    return axios.get(url);
};

export const getJsonGenerateForms = async (codes: string) => {
    let url = API_PATH_EMR + `/term-models/model-json`;
    return axios.get(url, { params: { codes } });
};

export const getListKhoaPhong = (searchObject: { type: number, level: number } ) => {
    let url = API_PATH_XADMIN + "/departments/search";
    return axios.get(url, {
        params: {
            ...searchObject,
            pageIndex: DEFAULT_PAGE_INDEX,
            pageSize: MAX_PAGE_SIZE,
        }
    });
}

export const cancelService = (data: any) => {
    let url = API_PATH_EMR + `/medical-exam/term/cancel`;
    return axios.post(url, data);
}

export const cancelServiceCLS = (data: any) => {
    let url = API_PATH_EMR + `/medical-exam/term/stop-executing`;
    return axios.post(url, data);
}

export const getUsers = (data: any) => {
    let url = API_PATH_SSO + `/users/search/advanced`;
    return axios.post(url, data);
}

export const saveObsValue = (data: any) => {
    let url = API_PATH_EMR + `/orders/obs`;
    return axios.post(url, data);
}

export const getHealthOrg = async (params: {
	pageSize: number;
	keyword: string;
}) => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH_INS}/health-org/search`, {
		params,
	});

	return data;
};

export const getHospitalCategory = async (params: {
	pageSize: number;
	pageIndex: number;
	keyword: string;
}) => {
	const { data } = await axios.get(
		`${API_PATH_EMR}/obs-complex-categories/dmbenhvien/search`,
		{
			params,
		}
	);
    
	return data;
};

export const getDepartmentConfig = async (params: {
	requestDeptCode: string;
}): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH_EMR}/service-department-conf`, {
		params,
	});
    return data;
};

export const callPatient = async (deptCode: string, action: string): Promise<OctResponse<any>> => {
    const { data } = await axios.post<OctResponse<any>>(`${API_PATH_EMR}/qms/patient-ticket/${action}`, null, {
        params: { deptCode },
    });
    return data;
};

export const getListPedingPatient = async (deptCode: string): Promise<OctResponse<any>> => {
    const { data } = await axios.get<OctResponse<any>>(`${API_PATH_EMR}/qms/patient-ticket`, {
        params: { deptCode },
    });
    return data;
};

export const getEventStreamFromText = (url: string, payload: FormData) => {
    return fetch(url, {
        method: 'POST',
        body: payload,
        headers: {
            Accept: 'text/event-stream',
        },
    });
};

export const getObsComplexCategory = async (params: {
    path: string;
    code: string;
	pageSize?: number;
	pageIndex?: number;
	keyword?: string;
}) => {
    const { path, code, pageSize = 999, pageIndex = 1, keyword } = params;
	const { data } = await axios.get(
		`${path}/obs-complex-categories/${code}/search`,
		{
			params: {
                pageIndex,
                pageSize,
                keyword,
            },
		}
	);
    
	return data;
};

export const searchTermModels = async (
	params: PagingParams & {
		tag?: string;
	}
) => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH_EMR}/term-models/search`, {
		params,
	});

	return data;
};

export const getObsValue = async (params: { orderId: string; encounterId: string }) => {
	const { data } = await axios.get<OctResponse<any>>(`${API_PATH_EMR}/obs`, {
		params,
	});

	return data;
};

export const getWarehouseProcess = async (params: {
    formCode: string;
    medicalItemTypeCode: string;
    visitObjectTypeCode: string;
}) => {
    const { data } = await axios.get<OctResponse<any>>(`${API_PATH_EMR}/cf/warehouse-process/search`, { params }); 
    return data;
};

export const getSignatureTree = async (baseUrl: string, params: {
	id: string;
	objectType: string;
	type: string;
	module?: string;
}) => {
	const { type, ...query } = params;
	const { data } = await axios.get<OctResponse<any>>(`${baseUrl}/template/${params.type}`, {
		params: query,
	});
    return data;
};

export const signFile = async (baseUrl: string, payload: {
	aggregateId: string;
	aggregateType: string;
	variable: string;
}) => {
	const { data } = await axios.post<OctResponse<any>>(`${baseUrl}/signature`, payload);
	return data;
};

// export const getSignatureResult = async (baseUrl: string, params: {
// 	aggregateId: string;
// 	aggregateType: string;
// }) => {
// 	const { data } = await axios.get<OctResponse<any>>(`${baseUrl}/signature/result`, { params });
// 	return data;
// };

export const getSignatureResult = async (baseUrl: string, jobId: string, params: {
	aggregateId: string;
	aggregateType: string;
}) => {
	const { data } = await axios.get<OctResponse<any>>(`${baseUrl}/signature/result/${jobId}`, { params });
	return data;
};

export const exportStorageFile = async (baseUrl: string, params: any) => {
	const response = await axios.post<Blob>(`${baseUrl}/storage/export`, null, {
		params,
		responseType: 'blob',
	});
    return response;
};

export const saveStorageFile = async (baseUrl: string, formData: FormData) => {
	const { data } = await axios.post<OctResponse<any>>(`${baseUrl}/storage`, formData);
    return data;
};

export const searchTerms = async (termCode: string | number, params: any) => {
	const { data } = await axios.post<OctResponse<any>>(
		`${API_PATH_EMR}/terms/class-id/${termCode}`,
		params
	);
	return data;
};

export const getDepartmentsByOrganization = async (
	params: PagingParams & {
		level: number;
		type: number;
		keyword?: string;
		parentCode?: string;
	}
) => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH_XADMIN}/departments/organization`,
		{
			params,
		}
	);
	return data;
};

export const getDepartmentsByModule = async (
	params: PagingParams & {
		level: number;
		moduleType: string;
	}
) => {
	const { moduleType, ...queryParams } = params;
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH_XADMIN}/departments/module/${moduleType}`,
		{
			params: queryParams,
		}
	);
	return data;
};